import { render, staticRenderFns } from "./WLink.vue?vue&type=template&id=07e1e399&scoped=true"
import script from "./WLink.vue?vue&type=script&lang=js"
export * from "./WLink.vue?vue&type=script&lang=js"
import style0 from "./WLink.vue?vue&type=style&index=0&id=07e1e399&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e1e399",
  null
  
)

export default component.exports